import { render, staticRenderFns } from "./RichTextView.vue?vue&type=template&id=f03b07b8&"
import script from "./RichTextView.vue?vue&type=script&lang=js&"
export * from "./RichTextView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports